import { render, staticRenderFns } from "./10MedalManagement.vue?vue&type=template&id=058f1cbb&scoped=true&"
import script from "./10MedalManagement.vue?vue&type=script&lang=js&"
export * from "./10MedalManagement.vue?vue&type=script&lang=js&"
import style0 from "./10MedalManagement.vue?vue&type=style&index=0&id=058f1cbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f1cbb",
  null
  
)

export default component.exports